import React, { useEffect, useState, useMemo } from "react";
import { useNavigate, Link,useParams, useSearchParams   } from "react-router-dom";
import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  ArcElement,
  CategoryScale,
  LinearScale,
  BarElement,
  LineElement,
  PointElement,
} from "chart.js";
import { Pie, Bar, Line } from "react-chartjs-2";
import { MoveDown, MoveUp,Calendar,X } from "lucide-react";
import axios from "axios";
import Select from 'react-select';
import "react-datepicker/dist/react-datepicker.css";
import { format } from "date-fns";
import DateRangePicker from "../components/DateRangePicker"; 


ChartJS.register(
  Title,
  Tooltip,
  Legend,
  ArcElement,
  CategoryScale,
  LinearScale,
  BarElement,
  LineElement,
  PointElement
);

export default function DashboardFilteredEvent() {

  const { id } = useParams();
  const [searchParams] = useSearchParams();
  const queryParams = new URLSearchParams(window.location.search);
  const [user, setUser] = useState(null);
  const [options, setOptions] = useState([]);
  const [selectedEvent, setSelectedEvent] = useState(null);

  const [ShowModalFilterAjuan, setShowModalFilterAjuan] = useState(false);
  const [showModal, setShowModal] = useState(false);
 
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  
  const [success, setSuccess] = useState(false);
  const navigate = useNavigate();

  const [data, setData] = useState(null);
   
 useEffect(() => {
    fetchEvents();
  }, []);

  const fetchEvents = async () => {
    setLoading(true);
    try {
      // Ganti URL API sesuai dengan endpoint kamu
      const res = await axios.get(`${process.env.REACT_APP_BASE_URL}api/events`);
      // Pastikan API mengembalikan data array seperti: [{id:1,name:"Event A"}, ...]
      const formatted = res.data.data.map((item) => ({
        value: item.id,
        label: item.name,
      }));
      setOptions(formatted);
    } catch (err) {
      console.error("Gagal memuat event:", err);
    } finally {
      setLoading(false);
    }
  };


  useEffect(() => {
      const storedUser = JSON.parse(localStorage.getItem("user"));
      const email = storedUser?.email;
      const level = storedUser?.level;
  
      fetch(`${process.env.REACT_APP_BASE_URL}api/users/search?email=${encodeURIComponent(email)}`)
          .then((res) => res.json())
          .then((data) => {
              if (data.status === "success") {
              setUser(data.data);
              console.log("Respon api search email:", data.data);
              } else {
              console.error(data.message);
              }
          })
          .catch((err) => console.error(err));
    }, []);
  const [loading, setLoading] = useState(true);
  const [eventName, setEventName] = useState("");
  const BASE = process.env.REACT_APP_BASE_URL || "";

  //paginate tabel tailwind list dashboard
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);
  const rowsPerPage = 10;
  const [currentPage, setCurrentPage] = useState(1);

  function formatDateIndo(dateStr) {
    const date = new Date(dateStr);
    if (isNaN(date)) return "Tanggal tidak valid";
    return date.toLocaleDateString("id-ID", {
      day: "numeric",
      month: "long",
      year: "numeric",
    });
  }

  useEffect(() => {
    let mounted = true;
    async function fetchData() {
      setLoading(true);
      try {
        const res = await fetch(`${BASE}api/dashboard/filteredEvent/${id}`);
        if (!res.ok) throw new Error("API error");
        const json = await res.json();
        if (mounted) setData(json);
        // ambil nama event
        const resName = await fetch(`${BASE}api/events/${id}`);
        if (resName.ok) {
          const jsonName = await resName.json();
          if (mounted) setEventName(jsonName.data.name || "");
        }
      } catch (err) {
        console.error("Gagal fetch dashboard:", err);
      } finally {
        if (mounted) setLoading(false);
      }
    }
    fetchData();
    return () => (mounted = false);
  }, [id,BASE]);

  const filteredData = useMemo(() => {
      return (data?.recent || []).filter((r) =>
        [r.note, r.pic, r.vendor, r.created_at, r.input_date]
          .join(" ")
          .toLowerCase()
          .includes(search.toLowerCase())
      );
    }, [data, search]);

    // Pagination logic
  const totalPages = Math.ceil(filteredData.length / rowsPerPage);
  const startIndex = (currentPage - 1) * rowsPerPage;
  const endIndex = startIndex + rowsPerPage;
  const currentData = filteredData.slice(startIndex, endIndex);

  // --- FUNGSI UNTUK WARNA KONDISIONAL ---
  const getTextColor = (r) => {
    if (r.trf === "0" && r.read === "unread") return "text-red-700";
    if (r.trf === "0") return "text-blue-700";
    if (r.trf === "1") return "text-green-700";
    return "text-gray-800";
  };

  // --- Pagination range hanya 3 halaman ---
  const getPageNumbers = () => {
    const delta = 1; // jumlah halaman di kiri-kanan
    let start = Math.max(1, currentPage - delta);
    let end = Math.min(totalPages, currentPage + delta);
    const pages = [];
    for (let i = start; i <= end; i++) {
      pages.push(i);
    }
    return pages;
  };

  if (loading || !data) {
    return (
      <div className="p-6">
        <p className="text-gray-500">Loading dashboard...</p>
      </div>
    );
  }

  // Chart data
  const lineData = {
    labels: data.trends.map((t) => t.month),
    datasets: [
      {
        label: "Total Ajuan",
        data: data.trends.map((t) => t.total),
        borderColor: "#4f46e5",
        backgroundColor: "#4f46e5",
      },
      {
        label: "Sudah Transfer",
        data: data.trends.map((t) => t.transfered),
        borderColor: "#10b981",
        backgroundColor: "#10b981",
      },
    ],
  };

  const barData = {
    labels: data.summary.typeDistribution.map((t) => t.type),
    datasets: [
      {
        label: "Jumlah",
        data: data.summary.typeDistribution.map((t) => t.count),
        backgroundColor: "#06b6d4",
      },
    ],
  };

  const pieData = {
    labels: data.statusDistribution.map((s) => s.name),
    datasets: [
      {
        data: data.statusDistribution.map((s) => s.value),
        backgroundColor: ["#10b981","#2649e9ff", "#f5f234ff", "#ef4444" ],
      },
    ],
  };

  const pieOptions = {
    plugins: {
      legend: {
        position: "left", 
        align: "center", 
        labels: {
          boxWidth: 15,
          padding: 20,
        },
      },
    },
  };

  const prev = data.summary.totalPrevMonth ?? 0;
  const now = data.summary.totalThisMonth ?? 0;

  const isUp = now > prev;
  const isDown = now < prev;
  const isSame = now === prev;

  const styleSelectReact = {
    control: (base) => ({
      ...base,
      borderColor: "#ced4da",
      boxShadow: "none",
      "&:hover": { borderColor: "#86b7fe" },
      borderRadius: "0.375rem", 
      width: "200px" 
    }),
    menu: (base) => ({
      ...base,
      zIndex: 9999,
    }),
  };

  const handleSelectChange = (selected) => {
    if (selected && selected.value) {
      // arahkan ke halaman baru dengan parameter id
      navigate(`/dashboardFilteredEvent/${selected.value}`);
    }
  };  

  return (
    <div className="p-6 space-y-4">
      {/* Header */}
        
      <header className="flex items-center justify-between">
        <h1 className="text-2xl font-semibold">Dashboard Event: 
          <p className="text-2xl font-semibold uppercase text-green-600">
            {eventName || "Memuat..."}
          </p>
        </h1>
        <div className="flex items-center gap-3">
          <button
            className="px-3 py-1 bg-indigo-600 text-white rounded hover:bg-indigo-700"
            onClick={() => window.location.reload()}  
          >
            Refresh
          </button>
          <button type="button"
            onClick={() => setShowModal(true)} className="flex items-center bg-green-500 hover:text-blue-500 hover:text-underlined text-white px-3 py-1 gap-2 text-md">
            <Calendar size={12} /> Filter Tanggal
          </button>
          <Select
              styles={styleSelectReact}
              options={options}
              value={selectedEvent}
              onChange={handleSelectChange}
              placeholder={loading ? "Memuat data..." : "Pilih Event"}
              isLoading={loading}
              isClearable
              isSearchable
          />
        {showModal && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
            <form className="space-y-4">
              <div className="bg-white p-6 rounded-lg shadow-xl max-w-md w-full">
                <h3 className="text-lg font-bold mb-4">Filter Tanggal</h3>
  
                {/* Komponen DateRange */}
                <DateRangePicker
                  startDate={startDate}
                  setStartDate={setStartDate}
                  endDate={endDate}
                  setEndDate={setEndDate}
                />
  
                <div className="flex justify-end gap-2 mt-6">
                  <button
                    onClick={() => setShowModal(false)}
                    className="px-4 py-2 bg-gray-300 hover:bg-gray-400 rounded"
                  >
                    Batal
                  </button>
                  <button
                    onClick={() => {
                      const start = startDate ? format(startDate, "yyyy-MM-dd") : "";
                      const end = endDate ? format(endDate, "yyyy-MM-dd") : "";
                      setShowModal(false);
                      navigate(`/dashboardFilteredDateEvent?start=${start}&end=${end}&id=${id}`);
                      setShowModal(false);                    
                    }}
                    className="px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded"
                  >
                    Terapkan
                  </button>
                </div>
              </div>
              </form>
          </div>
        )}
        </div>
      </header>
      {success && (
          <div className="mt-2 mb-4 bg-green-100 text-green-800 p-4 rounded shadow transition-all duration-30000 flex justify-between">
            <div className="">
              <h1 className="text-md font-bold"> Berhasil</h1>
              {success}
            </div>
            <button
              onClick={() => setSuccess(null)}
              className="ml-auto text-green-600 hover:text-green-800 transition"
            >
              <X size={16} />
            </button>
          </div>
        )}
      <section className="grid grid-cols-1 md:grid-cols-4 gap-4">
        <Card
          title="Total Nominal Ajuan"
          title2="Dari total Ajuan:"
          value={
            <div className="flex">
              {formatCurrency(data.summary.totalThisMonth)}
            </div>
          }
          value2={data.summary.totalAjuanThisMonth}
          color='black'
        />
        <Card
          title="total nominal belum transfer"
          value={formatCurrency(data.summary.totalUntransferThisMonth) || 0}
          title2="dari ajuan:"
          value2={data.summary.counts.byTransferStatus?.untransfered || 0}
          color='blue'
        />
        <Card 
          title="total nominal sudah transfer"
          value={formatCurrency(data.summary.totalTransferThisMonth) || 0}
          title2="dari ajuan:"
          value2={data.summary.counts.byTransferStatus?.transfered || 0}
          color='green'
        />
        <Card
          title="total nominal ajuan belum print"
          title2="dari ajuan:"
          value={formatCurrency(data.summary.totalUnprintedThisMonth) || 0}
          value2={data.summary.counts.byPrintStatus?.unread || 0}
          color='red'
        />
      </section>

      {/* Charts */}
      <section className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        <div className="col-span-2 bg-white rounded shadow p-4">
          <div className="flex justify-between p-4">
            <h3 className="font-medium text-xl mb-3">List Ajuan </h3>
            <input
              type="text"
              placeholder="Cari data..."
              value={search}
              onChange={(e) => {
                setSearch(e.target.value);
                setPage(1);
              }}
              className="border border-gray-300 rounded px-3 py-1 text-sm focus:outline-none focus:ring focus:ring-blue-300"
            />
          </div>
          {/* <Line data={lineData} /> */}
          <div className="overflow-x-auto">
            <table className="min-w-full text-sm">
              <thead>
                <tr className="text-left text-xs text-gray-500 uppercase">
                  <th className="p-2">No</th>
                  <th className="p-2">Tanggal</th>
                  <th className="p-2">Keterangan</th>
                  <th className="p-2">PIC</th>
                  <th className="p-2">Vendor</th>
                </tr>
              </thead>
              <tbody>
                 {currentData.length > 0 ? (
                    currentData.map((r, i) => (
                      <tr key={r.id} className={`border-t ${getTextColor(r)}`}>
                        <td className="p-2">{startIndex + i + 1}</td>
                        <td className="p-2">{formatDateIndo(r.input_date || r.created_at) || "-"}</td>
                        <td className="p-2">{r.note}</td>
                        <td className="p-2">{r.pic}</td>
                        <td className="p-2">{r.vendor}</td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="5" className="text-center p-3 text-gray-500">
                        Tidak ada data
                      </td>
                    </tr>
                  )}
              </tbody>
            </table>
            <div className="flex justify-center items-center mt-4 gap-1 text-sm">
              <button
                onClick={() => setCurrentPage(1)}
                disabled={currentPage === 1}
                className={`px-3 py-1 border rounded ${
                  currentPage === 1 ? "opacity-40 cursor-not-allowed" : ""
                }`}
              >
                First
              </button>
              <button
                onClick={() => setCurrentPage((p) => Math.max(1, p - 1))}
                disabled={currentPage === 1}
                className={`px-3 py-1 border rounded ${
                  currentPage === 1 ? "opacity-40 cursor-not-allowed" : ""
                }`}
              >
                Prev
              </button>

              {getPageNumbers().map((num) => (
                <button
                  key={num}
                  onClick={() => setCurrentPage(num)}
                  className={`px-3 py-1 border rounded ${
                    currentPage === num ? "bg-blue-500 text-white" : "bg-white"
                  }`}
                >
                  {num}
                </button>
              ))}

              <button
                onClick={() => setCurrentPage((p) => Math.min(totalPages, p + 1))}
                disabled={currentPage === totalPages}
                className={`px-3 py-1 border rounded ${
                  currentPage === totalPages ? "opacity-40 cursor-not-allowed" : ""
                }`}
              >
                Next
              </button>
              <button
                onClick={() => setCurrentPage(totalPages)}
                disabled={currentPage === totalPages}
                className={`px-3 py-1 border rounded ${
                  currentPage === totalPages ? "opacity-40 cursor-not-allowed" : ""
                }`}
              >
                Last
              </button>
            </div>
          </div>
        </div>

        <div className="bg-white rounded shadow p-4">
          <h3 className="font-medium mb-3">Distribusi Tipe Ajuan</h3>
          <Bar data={barData} />
            <h3 className="font-medium mb-3 mt-6">Status Transfer</h3>
            <Pie data={pieData} options={pieOptions} />
        </div>

      </section>

      <footer className="text-xs text-gray-500">
        * Data diambil dari API: <code>{`${BASE}api/dashboard`}</code>
      </footer>
    </div>
  );
}

// Komponen Card
function Card({ title, value, title2, value2,color }) {
  return (
    <div className="bg-white rounded-md shadow-md p-4 flex flex-col justify-between">
      <div className="text-sm text-gray-500 uppercase">{title}</div>
      <div className={`mt-2 text-2xl font-semibold text-${color}-600`}>{value}</div>
      <div className="text-sm mt-2 text-gray-500 uppercase">{title2}</div>
      <div className="mt-2 text-2xl font-semibold">{value2}</div>
    </div>
  );
}

// Format Rupiah
function formatCurrency(val) {
  if (val == null) return "-";
  const n = Number(val) || 0;
  return n.toLocaleString("id-ID", {
    style: "currency",
    currency: "IDR",
    maximumFractionDigits: 0,
  });
}
